import React from 'react';
import classNames from 'classnames';
export function BuyTieredPrice(_a) {
    var className = _a.className, style = _a.style, priceList = _a.priceList;
    return (React.createElement("div", { className: classNames('buy-tiered', className), style: style },
        React.createElement("ul", { className: "buy-tiered-list" }, priceList.map(function (item, index) { return (React.createElement("li", { key: index },
            React.createElement("span", { className: "buy-tiered-list-content" }, item.content),
            React.createElement("span", { className: "buy-tiered-list-value" }, item.value))); }))));
}
//# sourceMappingURL=BuyTieredPrice.js.map